import type { MouseEvent } from "react";
import { navigate } from "../../helpers/tixxt-router";
import { confirmNavigation } from "../../helpers/confirmNavigation";

export type ResultsLocationState = { backTo?: string } | null | undefined;

export function resultsPath(questionnaireId: string) {
  return `/questionnaires/${questionnaireId}/results`;
}

// remembers the page the results are opened from, the results' back button returns there
export function openResults(questionnaireId: string) {
  if (!confirmNavigation()) return;

  navigate(resultsPath(questionnaireId), {
    state: { backTo: `${location.pathname}${location.search}` },
  });
}

// for plain links: modified clicks still open a new tab, the app keeps its native back
export function onResultsLinkClick(
  event: MouseEvent<HTMLAnchorElement>,
  questionnaireId: string,
) {
  if (
    window.isApp ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
    return;

  event.preventDefault();
  openResults(questionnaireId);
}
